import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CtNavKeys } from '@cloud-twin-v2/navigation/ct-nav-keys';
import { AuthGuard } from '@common-modules/shared/auth/services/auth.guard';
import { TelemetryPageComponent } from './telemetry-page/telemetry-page.component';

const routes: Routes = [
  {
    path: '',
    component: TelemetryPageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.Measurements,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TelemetryRoutingModule { }
